import {
  getPricingOptionLabel,
  getPricingOptions,
  hasPricingOptions,
  hasSinglePricingOption,
  isDonationTicketDefinition,
  isPricingOptionsWithSamePrice,
} from '@wix/wix-events-commons-statics'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {
  getActivePricingOptionId,
  getActivePricingOptionLabel,
  getPlaceTicketPriceText,
  getPricingOptionsRangeLabel,
  getWholeTablePricingOptionsLabels,
  isPlaceReservableAsWhole,
} from '../../../../../selectors/seating/place'
import {TicketPriceProps} from './interfaces'
import {classes} from './ticket-price.st.css'

export const TicketPrice = ({place, inDrawer, inPopover, forcePricingOptionRangeLabel}: TicketPriceProps) => {
  const {t} = useTranslation()
  const {ticket} = place
  const {getFormattedMoney, getTicketPriceText} = useCurrencyFormatter()

  if (!ticket) {
    return null
  }

  const getPricingOptionsPriceLabels = () => {
    if (inPopover || inDrawer || !getActivePricingOptionId(place)) {
      if (hasSinglePricingOption(ticket)) {
        return [getPricingOptionLabel(ticket, getPricingOptions(ticket)[0].id, getFormattedMoney)]
      } else if (isPricingOptionsWithSamePrice(ticket)) {
        return [getTicketPriceText(getPricingOptions(ticket)[0].price)]
      } else {
        return [getPricingOptionsRangeLabel(ticket, t, getFormattedMoney)]
      }
    }

    if (isPlaceReservableAsWhole(place)) {
      return getWholeTablePricingOptionsLabels(place, t, getFormattedMoney)
    }

    if (forcePricingOptionRangeLabel && !hasSinglePricingOption(ticket)) {
      return [getPricingOptionsRangeLabel(ticket, t, getFormattedMoney)]
    }

    return [getActivePricingOptionLabel(place, getFormattedMoney)]
  }

  const getPriceLabels = () => {
    if (isDonationTicketDefinition(ticket)) {
      return [t('tickets.donation')]
    }

    if (hasPricingOptions(ticket)) {
      return getPricingOptionsPriceLabels()
    }

    return [getPlaceTicketPriceText({ticket, t, getTicketPriceText, getFormattedMoney})]
  }

  return (
    <>
      {getPriceLabels().map(label => (
        <Text key={label} className={classes.ticketPrice}>
          {label}
        </Text>
      ))}
    </>
  )
}
